import c from "../common";

export default {
  sender: "Sender",
  receiver: "Receiver",
  senderEmail: "Sender Email",
  senderName: "Sender Name",
  senderTel: "Sender Tel",
  receiverEmail: "Receiver Email",
  receiverName: "Receiver Name",
  receiverTel: "Receiver Tel",
  point: "point",

  description_1: "Search",
  description_2: " transfer record",
  description_3: "Search",
  description_4: "select date",
  description_5: "reset",
  description_6: "search",
  description_7: "last 7 days",
  description_8: "last 30 days",
  description_9: "custom",
  description_10: "select " + c.voucher.en.lowercase + " (optional)",
  description_11: "select all",
  description_12: "clear",
  description_13: "expiry",
  description_14: "selected",
  description_15: "no data",
  description_16: "please select date range",

};
